"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.showNerscLogin = exports.showGirderLogin = exports.showLoginOptions = exports.setMe = exports.setToken = exports.nerscLogin = exports.usernameLogin = exports.receiveMe = exports.requestMe = exports.loadMe = exports.setOauthEnabled = exports.testOauthEnabled = exports.receiveOauthProviders = exports.requestOauthProviders = exports.loadOauthProviders = exports.requestTokenFromApiKey = exports.loadTokenFromApiKey = exports.requestInvalidateToken = exports.invalidateToken = exports.setAuthenticating = exports.authenticate = exports.REQUEST_TOKEN_FROM_API_KEY = exports.LOAD_TOKEN_FROM_API_KEY = exports.SHOW_NERSC_LOGIN = exports.SHOW_GIRDER_LOGIN = exports.SHOW_LOGIN_OPTIONS = exports.SET_OAUTH_ENABLED = exports.TEST_OAUTH_ENABLED = exports.RECEIVE_OAUTH_PROVIDERS = exports.REQUEST_OAUTH_PROVIDERS = exports.LOAD_OAUTH_PROVIDERS = exports.REQUEST_ME = exports.LOAD_ME = exports.NERSC_LOGIN = exports.USERNAME_LOGIN = exports.REQUEST_INVALIDATE_TOKEN = exports.INVALIDATE_TOKEN = exports.SET_ME = exports.SET_AUTHENTICATING = exports.SET_TOKEN = exports.AUTHENTICATE = exports.getShowNerscLogin = exports.getShowGirderLogin = exports.getShowLoginOptions = exports.isOauthEnabled = exports.isAuthenticated = exports.isAuthenticating = exports.getOauthProviders = exports.getToken = exports.getMe = exports.setRoot = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

var _reduxActions = require("redux-actions");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var PREFIX = '@@girder-redux/auth/';
var initialState = {
  token: null,
  oauth: {
    providers: {},
    enabled: false
  },
  me: null,
  authenticating: false,
  error: null,
  ui: {
    showLoginOptions: false,
    girder: {
      show: false
    },
    nersc: {
      show: false
    }
  }
}; // Selectors

var getRoot = function getRoot(state) {
  return state;
};

var setRoot = function setRoot(getRootFn) {
  getRoot = getRootFn;
};

exports.setRoot = setRoot;

var getMe = function getMe(state) {
  return getRoot(state).me;
};

exports.getMe = getMe;

var getToken = function getToken(state) {
  return getRoot(state).token;
};

exports.getToken = getToken;

var getOauthProviders = function getOauthProviders(state) {
  return getRoot(state).oauth.providers;
};

exports.getOauthProviders = getOauthProviders;

var isAuthenticating = function isAuthenticating(state) {
  return getRoot(state).authenticating;
};

exports.isAuthenticating = isAuthenticating;

var isAuthenticated = function isAuthenticated(state) {
  return getRoot(state).token && !getRoot(state).authenticating;
};

exports.isAuthenticated = isAuthenticated;

var isOauthEnabled = function isOauthEnabled(state) {
  return getRoot(state).oauth.enabled;
};

exports.isOauthEnabled = isOauthEnabled;

var getShowLoginOptions = function getShowLoginOptions(state) {
  return getRoot(state).ui.showLoginOptions;
};

exports.getShowLoginOptions = getShowLoginOptions;

var getShowGirderLogin = function getShowGirderLogin(state) {
  return getRoot(state).ui.girder.show;
};

exports.getShowGirderLogin = getShowGirderLogin;

var getShowNerscLogin = function getShowNerscLogin(state) {
  return getRoot(state).ui.nersc.show;
}; // Actions


exports.getShowNerscLogin = getShowNerscLogin;
var AUTHENTICATE = PREFIX + 'AUTHENTICATE';
exports.AUTHENTICATE = AUTHENTICATE;
var SET_TOKEN = PREFIX + 'SET_TOKEN';
exports.SET_TOKEN = SET_TOKEN;
var SET_AUTHENTICATING = PREFIX + 'SET_AUTHENTICATING';
exports.SET_AUTHENTICATING = SET_AUTHENTICATING;
var SET_ME = PREFIX + 'SET_ME';
exports.SET_ME = SET_ME;
var INVALIDATE_TOKEN = PREFIX + 'INVALIDATE_TOKEN';
exports.INVALIDATE_TOKEN = INVALIDATE_TOKEN;
var REQUEST_INVALIDATE_TOKEN = PREFIX + 'REQUEST_INVALIDATE_TOKEN';
exports.REQUEST_INVALIDATE_TOKEN = REQUEST_INVALIDATE_TOKEN;
var USERNAME_LOGIN = PREFIX + 'USERNAME_LOGIN';
exports.USERNAME_LOGIN = USERNAME_LOGIN;
var NERSC_LOGIN = PREFIX + 'NERSC_LOGIN';
exports.NERSC_LOGIN = NERSC_LOGIN;
var LOAD_ME = PREFIX + 'LOAD_ME';
exports.LOAD_ME = LOAD_ME;
var REQUEST_ME = PREFIX + 'REQUEST_ME';
exports.REQUEST_ME = REQUEST_ME;
var LOAD_OAUTH_PROVIDERS = PREFIX + 'LOAD_OAUTH_PROVIDERS';
exports.LOAD_OAUTH_PROVIDERS = LOAD_OAUTH_PROVIDERS;
var REQUEST_OAUTH_PROVIDERS = PREFIX + 'REQUEST_OAUTH_PROVIDERS';
exports.REQUEST_OAUTH_PROVIDERS = REQUEST_OAUTH_PROVIDERS;
var RECEIVE_OAUTH_PROVIDERS = PREFIX + 'RECEIVE_OAUTH_PROVIDERS';
exports.RECEIVE_OAUTH_PROVIDERS = RECEIVE_OAUTH_PROVIDERS;
var TEST_OAUTH_ENABLED = PREFIX + 'TEST_OAUTH_ENABLED';
exports.TEST_OAUTH_ENABLED = TEST_OAUTH_ENABLED;
var SET_OAUTH_ENABLED = PREFIX + 'SET_OAUTH_ENABLED';
exports.SET_OAUTH_ENABLED = SET_OAUTH_ENABLED;
var SHOW_LOGIN_OPTIONS = PREFIX + 'SHOW_LOGIN_OPTIONS';
exports.SHOW_LOGIN_OPTIONS = SHOW_LOGIN_OPTIONS;
var SHOW_GIRDER_LOGIN = PREFIX + 'SHOW_GIRDER_LOGIN';
exports.SHOW_GIRDER_LOGIN = SHOW_GIRDER_LOGIN;
var SHOW_NERSC_LOGIN = PREFIX + 'SHOW_NERSC_LOGIN';
exports.SHOW_NERSC_LOGIN = SHOW_NERSC_LOGIN;
var LOAD_TOKEN_FROM_API_KEY = "LOAD_TOKEN_FROM_API_KEY";
exports.LOAD_TOKEN_FROM_API_KEY = LOAD_TOKEN_FROM_API_KEY;
var REQUEST_TOKEN_FROM_API_KEY = "REQUEST_TOKEN_FROM_API_KEY"; // Action creators

exports.REQUEST_TOKEN_FROM_API_KEY = REQUEST_TOKEN_FROM_API_KEY;
var authenticate = (0, _reduxActions.createAction)(AUTHENTICATE);
exports.authenticate = authenticate;
var setAuthenticating = (0, _reduxActions.createAction)(SET_AUTHENTICATING);
exports.setAuthenticating = setAuthenticating;
var invalidateToken = (0, _reduxActions.createAction)(INVALIDATE_TOKEN);
exports.invalidateToken = invalidateToken;
var requestInvalidateToken = (0, _reduxActions.createAction)(REQUEST_INVALIDATE_TOKEN);
exports.requestInvalidateToken = requestInvalidateToken;
var loadTokenFromApiKey = (0, _reduxActions.createAction)(LOAD_TOKEN_FROM_API_KEY);
exports.loadTokenFromApiKey = loadTokenFromApiKey;
var requestTokenFromApiKey = (0, _reduxActions.createAction)(REQUEST_TOKEN_FROM_API_KEY);
exports.requestTokenFromApiKey = requestTokenFromApiKey;
var loadOauthProviders = (0, _reduxActions.createAction)(LOAD_OAUTH_PROVIDERS);
exports.loadOauthProviders = loadOauthProviders;
var requestOauthProviders = (0, _reduxActions.createAction)(REQUEST_OAUTH_PROVIDERS);
exports.requestOauthProviders = requestOauthProviders;
var receiveOauthProviders = (0, _reduxActions.createAction)(RECEIVE_OAUTH_PROVIDERS);
exports.receiveOauthProviders = receiveOauthProviders;
var testOauthEnabled = (0, _reduxActions.createAction)(TEST_OAUTH_ENABLED);
exports.testOauthEnabled = testOauthEnabled;
var setOauthEnabled = (0, _reduxActions.createAction)(SET_OAUTH_ENABLED);
exports.setOauthEnabled = setOauthEnabled;
var loadMe = (0, _reduxActions.createAction)(LOAD_ME);
exports.loadMe = loadMe;
var requestMe = (0, _reduxActions.createAction)(REQUEST_ME);
exports.requestMe = requestMe;
var receiveMe = (0, _reduxActions.createAction)(SET_ME);
exports.receiveMe = receiveMe;
var usernameLogin = (0, _reduxActions.createAction)(USERNAME_LOGIN);
exports.usernameLogin = usernameLogin;
var nerscLogin = (0, _reduxActions.createAction)(NERSC_LOGIN);
exports.nerscLogin = nerscLogin;
var setToken = (0, _reduxActions.createAction)(SET_TOKEN);
exports.setToken = setToken;
var setMe = (0, _reduxActions.createAction)(SET_ME);
exports.setMe = setMe;
var showLoginOptions = (0, _reduxActions.createAction)(SHOW_LOGIN_OPTIONS);
exports.showLoginOptions = showLoginOptions;
var showGirderLogin = (0, _reduxActions.createAction)(SHOW_GIRDER_LOGIN);
exports.showGirderLogin = showGirderLogin;
var showNerscLogin = (0, _reduxActions.createAction)(SHOW_NERSC_LOGIN); // Reducer
// For some reason the reducer created by redux-actions' handleActions() doesn't
// seem to work. For the sake of time, implementing a plain reducer instead.

exports.showNerscLogin = showNerscLogin;

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_TOKEN:
      {
        var token = action.payload; // const providers = null;
        // const oauth = {
        //     providers
        // }

        return _objectSpread({}, state, {
          token: token
        });
      }

    case SET_AUTHENTICATING:
      {
        var authenticating = action.payload;
        return _objectSpread({}, state, {
          authenticating: authenticating
        });
      }

    case SET_ME:
      {
        var me = action.payload;
        return _objectSpread({}, state, {
          me: me
        });
      }

    case REQUEST_INVALIDATE_TOKEN:
      {
        if (action.error) {
          return _objectSpread({}, state, {
            error: action.payload.error
          });
        } else {
          return _objectSpread({}, state, {
            error: null
          });
        }
      }

    case REQUEST_OAUTH_PROVIDERS:
      {
        if (action.error) {
          return _objectSpread({}, state, {
            error: action.payload.error
          });
        } else {
          return _objectSpread({}, state, {
            error: null
          });
        }
      }

    case SET_OAUTH_ENABLED:
      {
        var enabled = action.payload;

        var oauth = _objectSpread({}, state.oauth, {
          enabled: enabled
        });

        return _objectSpread({}, state, {
          oauth: oauth
        });
      }

    case RECEIVE_OAUTH_PROVIDERS:
      {
        var providers = action.payload;

        var _oauth = _objectSpread({}, state.oauth, {
          providers: providers
        });

        return _objectSpread({}, state, {
          oauth: _oauth
        });
      }

    case SHOW_LOGIN_OPTIONS:
      {
        var show = action.payload;

        var ui = _objectSpread({}, state.ui);

        ui.showLoginOptions = show;
        return _objectSpread({}, state, {
          ui: ui
        });
      }

    case SHOW_GIRDER_LOGIN:
      {
        var _show = action.payload;

        var _ui = _objectSpread({}, state.ui);

        _ui.girder = {
          show: _show
        };
        return _objectSpread({}, state, {
          ui: _ui
        });
      }

    case SHOW_NERSC_LOGIN:
      {
        var _show2 = action.payload;

        var _ui2 = _objectSpread({}, state.ui);

        _ui2.nersc = {
          show: _show2
        };
        return _objectSpread({}, state, {
          ui: _ui2
        });
      }

    default:
      {
        return state;
      }
  }
}

var _default = reducer;
exports.default = _default;